<ng-container *transloco="let t; prefix: 'credential-verification-level'">
  <div
    class="verification-level"
    [attr.data-cy]="'chip-verification-level-' + level()"
    [matTooltip]="t('tooltip.' + level())">
    <img
      [ngSrc]="'assets/images/custom-credentials/confidence-level/' + level() + '.svg'"
      width="16"
      height="16"
      alt="" />

    <div>{{ t('user_uploaded') }}</div>
  </div>

  <div class="sr-only">
    {{ t('tooltip.' + level()) }}
  </div>
</ng-container>
